import { Component, forwardRef, HostBinding, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

/**
 * Komponenta input pro objekt číselníku. Edituje pouze popisek. Kód je null.
 * */

@Component({
  selector: 'app-cisenik-input',
  template: '<input [id]="id" type="text" [(ngModel)]="inputValue" [disabled]="disabled" />',
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => CisenikInputComponent),
    multi: true
  }],
  standalone: false
})
export class CisenikInputComponent implements ControlValueAccessor {

  constructor() { }

  private _id = '';

  // finta s ID odkoukána zde: https://coryrylan.com/blog/angular-custom-form-controls-with-reactive-forms-and-ngmodel
  @HostBinding('attr.id')
  externalId = '';

  @Input()
  set id(value: string) {
    this._id = value;
    this.externalId = null;
  }

  get id() {
    return this._id;
  }

  // Proměnné pro implementaci rozhraní ControlValueAccessor
  onModelChange: any = () => { };
  onModelTouched: any = () => { };
  disabled: boolean = false;


  @Input('value') _value: any = null;

  //pomocná proměnná pro řevod objektu číselníku na text
  _inputValue: string;
  get inputValue() {
    return this._inputValue;
  }
  set inputValue(val) {
    this.value = val;
  }

  get value() {
    return this._value;
  }

  set value(val) {
    if (val != void 0 && typeof (val) == "string" && val != "") {
      val = {
        popis: val, kod: null
      };
    } else {
      val = null;
    }
    if (val != this._value) {
      this._value = val;
      this._inputValue = val != void 0 ? val.popis : "";
      this.onModelChange(val);
      this.onModelTouched();
    }
  }


  // Implementace rozhraní ControlValueAccessor
  writeValue(obj: any): void {
    this.value = obj;
  }

  // Implementace rozhraní ControlValueAccessor
  registerOnChange(fn: any): void {
    this.onModelChange = fn;
  }

  // Implementace rozhraní ControlValueAccessor
  registerOnTouched(fn: any): void {
    this.onModelTouched = fn;
  }

  // Implementace rozhraní ControlValueAccessor
  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
